export default class IconWithTypes {
  constructor(public id: string, public iconUrl: string, public types: (string | number)[]) {}
}
